import React, { useState } from "react"
import { Color, Spacing } from "@persona-id/design-tokens"
import defaultTheme from "@persona-id/design-system/theme"
import styled, { ThemeProvider } from "styled-components"

import { PageContext } from "../models/contentful"
import NavigationTop from "../components/NavigationTop"
import NavigationLeft from "../components/NavigationLeft"
import NavigationLeftMobile from "../components/NavigationLeftMobile"

import "./layout.css"

const PageLayout = ({
  children,
  pageContext,
}: {
  children: JSX.Element
  pageContext: PageContext
}) => {
  const [showNavigationLeftMobile, setShowNavigationMobile] = useState(false)
  const toggleNavigationLeftMobile = () => {
    setShowNavigationMobile(!showNavigationLeftMobile)
  }

  const currentCategory =
    pageContext?.contentfulCategory ||
    pageContext?.contentfulHelpCenterArticle?.subtopic?.[0]?.topic?.[0]
      ?.category?.[0]

  const currentTopic =
    pageContext?.contentfulTopic ||
    pageContext?.contentfulHelpCenterArticle?.subtopic?.[0]?.topic?.[0]

  const currentSubtopic =
    pageContext?.contentfulSubtopic ||
    pageContext?.contentfulHelpCenterArticle?.subtopic?.[0]

  return (
    <ThemeProvider theme={defaultTheme}>
      <PageWrapper>
        <NavigationTopWrapper>
          <NavigationTop
            toggleNavigationLeftMobile={toggleNavigationLeftMobile}
            closeNavigationLeftMobile={() => setShowNavigationMobile(false)}
          />
        </NavigationTopWrapper>
        <ContentWrapper>
          {showNavigationLeftMobile && (
            <NavigationLeftMobile
              currentCategory={currentCategory}
              closeMobileNav={() => setShowNavigationMobile(false)}
            />
          )}
          <NavigationLeftWrapper>
            <NavigationLeft
              pageContext={pageContext}
              currentCategory={currentCategory}
              currentTopic={currentTopic}
              currentSubtopic={currentSubtopic}
            />
          </NavigationLeftWrapper>
          <ContentChildrenWrapper>{children}</ContentChildrenWrapper>
        </ContentWrapper>
      </PageWrapper>
    </ThemeProvider>
  )
}

const PageWrapper = styled.div`
  width: 100%;
  background-color: ${Color.CoreSlate50};
  height: 100%;
  min-height: 100vh;
`

const ContentWrapper = styled.div`
  max-width: 1550px;
  margin: auto;
  padding: ${Spacing[6]};
  padding-top: 80px;
  display: flex;
  flex-direction: row;
  column-gap: ${Spacing[6]};
  position: relative; // for NavigationLeftMobile

  @media (max-width: 900px) {
    padding: ${Spacing[3]};
    padding-top: 68px;
  }
`

const NavigationTopWrapper = styled.div`
  position: fixed;
  width: 100%;
  z-index: 2;
`

const NavigationLeftWrapper = styled.div`
  position: fixed;
  z-index: 2;
  height: 80%;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none;
  }
`

const ContentChildrenWrapper = styled.div`
  padding-left: 300px;
  width: 100%;

  @media (max-width: 900px) {
    padding-left: 0px;
  }
`

export default PageLayout
